import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { createDownloadLink } from '@/utils'
import { message } from 'ant-design-vue'
import router from '@/router/index.js'
import base from '@/assets/base/base';

const delCookie = () => {
  var keys = document.cookie.match(/[^ =;]+(?==)/g)
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie =
        keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
      document.cookie =
        keys[i] +
        '=0;path=/;domain=' +
        document.domain +
        ';expires=' +
        new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
      document.cookie =
        keys[i] +
        '=0;path=/;domain=zju.edu.cn;expires=' +
        new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
    }
  }
}
/**退出登录 */
const toLogout = () => {
  delCookie()
  sessionStorage.clear()
  sessionStorage.getItem('uuid') || ''
  router.replace("/index")
}
// request拦截器
axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return error
  }
)

axios.defaults.transformRequest = function (data, headers) {

  if (
    headers['Content-Type'] === 'application/x-www-form-urlencoded' &&
    data &&
    Object.prototype.toString.call(data) === '[object Object]'
  ) {
    data = {
      ...data,
    }
    data = qs.stringify(data)
  } else if (headers['Content-Type'] === 'application/json') {
    data = {
      ...data,
    }
    data = JSON.stringify(data)
  }
  return data
}
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // api的base_url
  timeout: 15000 // 请求超时时间
})

//创建axios请求拦截
service.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (sessionStorage.getItem('token')) {
    let url=config.url.split('?')[0]
    config.headers["Authorization"] = sessionStorage.getItem('token') + "_T" + base.encryptAES(url)
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
})



// respone拦截器
service.interceptors.response.use(
  res => {
    const { data, config } = res
    const { code, msg } = data
    if (code === 200) {
      return Promise.resolve(res.data)
    } else if (
      code == 5011 ||
      code == 5012 ||
      code == 5013 ||
      data.msg == '认证信息失效，请返回首页重新认证!'
    ) {
      //重新登录
      toLogout()
    } else if (
      code == 3016 ||
      code == 3018) {
      return Promise.resolve(res.data)
    } else {
      message.error(data.msg)
      return Promise.reject(res)
    }
  },
  err => {
    console.log('网络异常')
    return Promise.reject(err)
  }
)

export function request(_param) {
  const {
    method = 'get',
    // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
    responseType = 'json', // 默认的
    headers = {},
    url = '',
    params,
    data,
    ...otherData
  } = _param

  if (!url) {
    return new Promise((resolve, reject) => {
      reject(new Error('url is null'))
    })
  }
  const _method = method.toLowerCase()
  if (_method === 'get') {
    return axios({
      responseType,
      url,
      baseURL: process.env.VUE_APP_API_URL,
      headers,
      method,
      params: params || data || otherData
    })
  }

  if (_method === 'delete' || _method === 'put') {
    if (!Object.prototype.hasOwnProperty.call(headers, 'Content-Type')) {
      headers['Content-Type'] =
        'application/x-www-form-urlencoded;charset=UTF-8'
    }
    return axios({
      responseType,
      url,
      baseURL: process.env.VUE_APP_API_URL,
      headers,
      method,
      data,
      params: params || data || otherData
    })
  }

  if (_method === 'post') {
    if (!Object.prototype.hasOwnProperty.call(headers, 'Content-Type')) {
      headers['Content-Type'] =
        'application/x-www-form-urlencoded;charset=UTF-8'
    }
    if (params && data) {
      return axios({
        responseType,
        url,
        headers,
        baseURL: process.env.VUE_APP_API_URL,
        method,
        params,
        data
      })
    } else {
      const { start, limit, ...resetData } = otherData
      return axios({
        responseType,
        url,
        headers,
        baseURL: process.env.VUE_APP_API_URL,
        method,
        params: params || { start, limit },
        data: data || resetData
      })
    }
  }
}
export function download(_param) {
  // eslint-disable-next-line no-prototype-builtins
  if (!_param.hasOwnProperty('responseType')) {
    _param.responseType = 'blob'
  }
  return request(_param)
    .then(res => {
      if (res.status === 200 && res.request.readyState === 4) {
        createDownloadLink(res, _param.params)
      } else {
        console.log('message: 下载失败')
      }
      return res
    })
    .catch(error => {
      console.log(error)
      return error
    })
}
export default service
